import React from 'react';
import Chip from '@mui/material/Chip';

export const notificationCounts = (rows) => {
  const counts = { total: rows.length, pending: 0, sent: 0, failed: 0, unknown: 0, skipped: 0, unshared: 0 };
  rows.forEach(row => {
    const status = row.notification_status || (row.notified ? 'sent' : 'unshared');
    counts[Object.prototype.hasOwnProperty.call(counts, status) ? status : 'unknown'] += 1;
  });
  return counts;
};

export const notificationLabel = (status, counts) => {
  if (counts?.sent > 0 && counts.sent < counts.total) {
    return `Kısmen gönderildi: ${counts.sent}/${counts.total}`;
  }
  return ({
  pending: 'Kuyrukta',
  sent: 'Gönderildi',
  failed: 'Başarısız',
  unknown: 'Durum belirsiz',
  skipped: 'Atlandı',
  }[status] || 'Paylaşım bekliyor');
};

export const notificationColor = (status) => ({
  pending: 'warning', sent: 'success', failed: 'error', unknown: 'warning',
}[status] || 'default');

export default function NotificationStatusChip({ status, counts, ...props }) {
  const partial = counts?.sent > 0 && counts.sent < counts.total;
  return <Chip size="small" label={notificationLabel(status, counts)} color={partial ? 'warning' : notificationColor(status)} {...props} />;
}
